import { render } from "./kuaishou.vue?vue&type=template&id=5364698e"
import script from "./kuaishou.vue?vue&type=script&lang=js"
export * from "./kuaishou.vue?vue&type=script&lang=js"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__